import axios from '../utils/axios';

export default function updateCompanyId(adminId,params) {
    return axios.post('/admin/' + adminId + '/update-recruiters-company', params);
}
